
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Courses() {
  const craftCourses = [
    {
      title: 'ハウスケア',
      duration: '所要時間：約1.5時間',
      price: '4,800円（税込）',
      description: '日本産精油３種を贅沢に使い、キッチン/トイレ/下足などの気になる臭いや、クローゼットの防虫対策、感染症対策など、ハウスケア全般に役立てられる「消臭/防虫/抗菌スプレー」を作成します。',
      image: 'https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/75db62c0e5d629eb00ef219689e88550.jfif'
    },
    {
      title: 'スキンケア',
      duration: '所要時間：約1.5～2時間',
      price: '4,500～8,400円（税込）',
      description: '日本産精油２種と国産のキャリアオイル（化粧水の場合は国産ハーブウォーター）により、化粧水・美容オイル・リップクリーム・ハンドクリームなどのスキンケア用品を作成します。※お好きなクラフトを自由にお選びいただくことができます。詳細はお問合せください。',
      image: 'https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/a0298566a470726e7a7cc0b7fcfc0873.jfif'
    },
    {
      title: 'セルフケア',
      duration: '所要時間：約1.5～2時間',
      price: '5,500～6,200円（税込）',
      description: 'お身体の悩みに合わせた日本産精油２種と国産のキャリアオイルを用いて、マッサージオイルを作成しセルフマッサージの方法も学びます。ご希望の方は入浴剤やロールオンアロマも作成いただけます。※入浴剤とロールオンアロマは自由にお選びいただけます。詳細はお問い合わせください。',
      image: 'https://public.readdy.ai/ai/img_res/d204f70a4dc132e50c75b17bcc0a4e54.jpg'
    }
  ];

  const advisorProgram = {
    title: 'yuica認定日本産精油アドバイザー資格講座',
    duration: '全6回（各3時間）',
    price: '411,000円（税込）',
    description: '和精油の基礎知識から応用まで、体系的に学べる資格取得コース。修了後は認定証を発行いたします。',
    curriculum: [
      '和精油の歴史と特徴',
      '主要な和精油の種類と効能',
      'ブレンド技術の基礎',
      '安全な使用方法',
      'アロマクラフト実習',
      '資格認定試験'
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-green-50">
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">講座一覧</h1>
        </div>
      </section>

      {/* Craft Courses Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">日本産精油の入門講座</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto mb-8">
              初心者の方でも気軽にご参加いただける、楽しいクラフト講座です。
              和精油の香りを楽しみながら、実用的なアイテムを手作りしましょう。講座の流れと内容は以下のとおりです。
            </p>
            <div className="max-w-3xl mx-auto text-left">
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3">🌿</span>
                  <span>日本の森林の現状</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">🌿</span>
                  <span>日本の香り文化と日本産精油の誕生</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">🌿</span>
                  <span>精油の作られ方、正しい選び方</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">🌿</span>
                  <span>日本産精油を学ぼう　※各コースで２～３種類</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3">🌿</span>
                  <span>日本産精油を使ったクラフト</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {craftCourses.map((course, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{course.title}</h3>
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-green-600 font-semibold">{course.price}</span>
                    <span className="text-gray-500 text-sm">{course.duration}</span>
                  </div>
                  <p className="text-gray-600 text-sm mb-4">{course.description}</p>
                  <Link to="/contact">
                    <Button className="w-full">
                      お申し込み
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisor Course Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-award-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">yuica認定日本産精油アドバイザー資格講座</h3>
            </div>
            
            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-gray-900 mb-3">講座概要</h4>
                <p className="text-gray-600 leading-relaxed">
                  日本産精油の専門知識を体系的に学び、アドバイザー資格を取得できる本格的な講座です。
                  日本の森林から生まれた精油の特性や活用法を深く理解し、他の方にもアドバイスできるレベルの知識を身につけます。
                </p>
              </div>

              <p className="text-gray-600 mb-6">
                yuica認定日本産精油アドバイザー資格講座は、日本産精油の基礎知識から実践的な活用方法まで、
                体系的に学べる認定講座です。yuicaの公式カリキュラムに基づき、
                和精油の専門知識を身につけることができます。
              </p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-time-line mr-3 text-green-600"></i>
                  計6時間（２時間×全３回）※受講生様のご都合に合わせ、１回の時間と回数は調整可能です
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-yen-circle-line mr-3 text-green-600"></i>
                  受講料：22,000円（税込）※実習費含む
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-book-line mr-3 text-green-600"></i>
                  教材費・試験受験料・認定料：30,800円（税込）
                </div>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-calendar-line mr-3 text-green-600"></i>
                  個別相談（マンツーマンのため、早朝・深夜など柔軟に調整可能）
                </div>
              </div>

              <Link to="/advisor-course">
                <Button className="w-full lg:w-auto px-8">
                  講座詳細
                </Button>
              </Link>
              <div className="order-1 lg:order-2">
                <img 
                  src="https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/b8eb678a7c26b7839d59031ae2865284.jfif"
                  alt="アドバイザー資格講座"
                  className="w-full h-80 lg:h-full object-cover object-top mt-8"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 pb-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">受講のメリット</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">マンツーマン制</h3>
              <p className="text-gray-600 text-sm">１対１のきめ細やかな個人指導
 （希望される方はご家族やご友人との受講も可能です）</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">個別スケジューリング</h3>
              <p className="text-gray-600 text-sm">受講日程は、早朝・深夜・土日祝など柔軟に調整可能</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-gift-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">材料費込み</h3>
              <p className="text-gray-600 text-sm">講座料金には材料費が含まれており、追加費用は一切かかりません。</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">アフターサポート</h3>
              <p className="text-gray-600 text-sm">受講後も質問や相談に対応し、継続的にサポートいたします。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
